import { useEffect, useState } from 'react';

// In-memory progress of uploads running in this tab, keyed by upload_id. The server only learns
// about finished files later, so the Upload Progress view overlays these live numbers on its rows.
let uploads = {};
const listeners = new Set();

export const LIVE_STATUS = { UPLOADING: 'UPLOADING', DONE: 'DONE' };

export const updateLiveUpload = (uploadId, data) => {
  uploads = { ...uploads, [uploadId]: { ...uploads[uploadId], ...data, uploadId } };
  listeners.forEach(listener => listener(uploads));
};

export const getLiveUploads = () => uploads;

export const subscribeLiveUploads = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useLiveUploads = () => {
  const [state, setState] = useState(getLiveUploads);
  useEffect(() => {
    setState(getLiveUploads());
    return subscribeLiveUploads(setState);
  }, []);
  return state;
};
